import { type Address, formatAddress } from "@inrev/common";
import { type Control, type FieldValues, type Path } from "react-hook-form";
import { Icon } from "../../primitives";
import { FormSearchableSelectList } from "./FormSearchableSelectList";

type PrincipalPreviewItem = {
	companyContactId: string;
	name: string;
	address: Address | string;
	accountDisplayName?: string;
	searchValues: string[];
};

export const SelectPrincipalListItem = (
	props: Pick<PrincipalPreviewItem, "name" | "address" | "accountDisplayName">,
) => (
	<div className="w-full flex py-[20px] px-[30px]">
		<div className="flex flex-col flex-1 space-y-[15px]">
			<div className="flex flex-col space-y-[3px]">
				<div className="flex font-medium text-primary space-x-[12px]">
					<Icon type="building-office" className="text-[18px] text-primary mt-[3px]" />
					<span>{props.name}</span>
				</div>
				<div className="font-normal text-secondary text-sm">{formatAddress(props.address)}</div>
			</div>
		</div>
	</div>
);

type SelectPrincipalFormSectionProps<TFieldValues extends FieldValues> = {
	name: Path<TFieldValues>;
	control: Control<TFieldValues>;
	principalPreviews: Record<string, PrincipalPreviewItem>;
	selectedPrincipal?: Pick<PrincipalPreviewItem, "name" | "address" | "accountDisplayName">;
	listMaxHeight?: string;
};

export const SelectPrincipalFormSection = <TFieldValues extends FieldValues>({
	name,
	control,
	principalPreviews,
	selectedPrincipal,
	listMaxHeight,
}: SelectPrincipalFormSectionProps<TFieldValues>) => (
	<FormSearchableSelectList
		name={name}
		control={control}
		searchPlaceholder="Search principals..."
		listMaxHeight={listMaxHeight}
		listItems={Object.entries(principalPreviews).map(([key, preview]) => ({
			value: preview.companyContactId,
			element: <SelectPrincipalListItem key={key} {...preview} />,
			searchValues: preview.searchValues,
		}))}
		selectedListItemElement={
			selectedPrincipal ? <SelectPrincipalListItem {...selectedPrincipal} /> : undefined
		}
	/>
);
